import BN from "bn.js";
export const FEE_RATE_DENOMINATOR_VALUE = new BN(1_000_000);
